import { IStyle, mergeStyleSets } from "@fluentui/react";

export const contactListStyles = mergeStyleSets({
  iconCss: {
    fontSize: 14,
    height: 25,
    width: 25,
    margin: "2px 2px 2px 2px",
    color: "rgb(0, 120, 212)",
    cursor: "pointer"
  } as IStyle,
  contactName: {
    minWidth: "215px",
    maxWidth: "215px",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    overflowX: "hidden"
  } as IStyle,
  contactJob: {
    fontSize: "10px",
    color: "gray",
    marginTop: "5px"
  } as IStyle,
  tableBorder: {
    border: "none"
  } as IStyle,
  proImg: {
    color: "rgb(0, 121, 214)",
    backgroundColor: "rgb(230, 250, 255)",
    borderRadius: "50%",
    display: "inline-block",
    padding: "10px",
    fontSize: "16px",
    minWidth: "25px",
    maxWidth: "25px"
  } as IStyle,
  imgLabel: {
    alignContent: "center",
    padding: "8px 8px 12px 8px"
  } as IStyle,
  contactDiv: {
    paddingLeft: "15px"
  } as IStyle,
  divTag: {
    paddingTop: "10px"
  } as IStyle,
  titleArea: {
    fontWeight: 600
  } as IStyle,
  contactInfo: {
    display: "flex",
    minWidth: 20,
    maxWidth: 20
  } as IStyle
});
